import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddGroup = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M2.35742 4.3125C2.35742 3.76549 2.57472 3.24089 2.96151 2.85409C3.34831 2.4673 3.87291 2.25 4.41992 2.25H13.7949C14.3419 2.25 14.8665 2.4673 15.2533 2.85409C15.6401 3.24089 15.8574 3.76549 15.8574 4.3125V9.08625C15.5085 8.84974 15.1304 8.65965 14.7324 8.52075V4.3125C14.7324 3.795 14.3124 3.375 13.7949 3.375H4.41992C3.90242 3.375 3.48242 3.795 3.48242 4.3125V13.6875C3.48242 14.205 3.90242 14.625 4.41992 14.625H8.48567C8.61542 15.0255 8.79467 15.4028 9.01742 15.75H4.41992C3.87291 15.75 3.34831 15.5327 2.96151 15.1459C2.57472 14.7591 2.35742 14.2345 2.35742 13.6875V4.3125Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.25 13.125C17.25 12.031 16.8154 10.9818 16.0418 10.2082C15.2682 9.4346 14.219 9 13.125 9C12.031 9 10.9818 9.4346 10.2082 10.2082C9.4346 10.9818 9 12.031 9 13.125C9 14.219 9.4346 15.2682 10.2082 16.0418C10.9818 16.8154 12.031 17.25 13.125 17.25C14.219 17.25 15.2682 16.8154 16.0418 16.0418C16.8154 15.2682 17.25 14.219 17.25 13.125ZM13.5007 13.5V15.3773C13.5007 15.4767 13.4612 15.5721 13.3909 15.6424C13.3206 15.7127 13.2252 15.7523 13.1257 15.7523C13.0263 15.7523 12.9309 15.7127 12.8606 15.6424C12.7903 15.5721 12.7507 15.4767 12.7507 15.3773V13.5H10.8727C10.7733 13.5 10.6779 13.4605 10.6076 13.3902C10.5373 13.3198 10.4977 13.2245 10.4977 13.125C10.4977 13.0255 10.5373 12.9302 10.6076 12.8598C10.6779 12.7895 10.7733 12.75 10.8727 12.75H12.75V10.875C12.75 10.7755 12.7895 10.6802 12.8598 10.6098C12.9302 10.5395 13.0255 10.5 13.125 10.5C13.2245 10.5 13.3198 10.5395 13.3902 10.6098C13.4605 10.6802 13.5 10.7755 13.5 10.875V12.75H15.3773C15.4767 12.75 15.5721 12.7895 15.6424 12.8598C15.7127 12.9302 15.7523 13.0255 15.7523 13.125C15.7523 13.2245 15.7127 13.3198 15.6424 13.3902C15.5721 13.4605 15.4767 13.5 15.3773 13.5H13.5007Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgAddGroup);
export default ForwardRef;
